// For tagging millisec
export type ms = number;

export const MILLISECOND: ms = 1;
export const SECOND: ms = 1000 * MILLISECOND;
export const MINUTE: ms = 60 * SECOND;
export const HOUR: ms = 60 * MINUTE;
export const DAY: ms = 24 * HOUR;
